import { Timestamp } from "./date"
import { UserRef } from "./user"

export const ActivityThresholdSeconds = 5 * 60
export const TypingThresholdSeconds = 60

export interface PendingBotResponse {
  chat_id?: number
  responding_to_user_ref?: UserRef
  timestamp: Timestamp
  stream_id: string
}

export interface UserPresenceStatus {
  user_ref: UserRef
  presence_type: UserPresenceType
  timestamp: Timestamp
}

export type UserPresenceType = "active" | "typing"
